import React, { useState } from 'react';
import { navigationLinks, brandName } from '../data/navigation';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-brand">
          <h2>{brandName}</h2>
        </div>
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {navigationLinks.map((link, index) => (
            <a key={index} href={link.href} className="nav-link">{link.label}</a>
          ))}
        </div>
        <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
      
    </header>
  );
};

export default Header;